<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-text-field
          label="Fee Waive Cycles"
          v-model="workingReward.feeWaiveCycles"
          type="number"
          hint="Ex. 2"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="feeWaiveCycles"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { WaiveServiceFeeReward } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class WaiveServiceFeeRewardEditor extends Vue {
  @Prop()
  value!:WaiveServiceFeeReward;

  workingReward:WaiveServiceFeeReward | null = null;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as WaiveServiceFeeReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
